export default "__VITE_ASSET__D9KrMh2K__"